"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionToolbar = void 0;
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("DataStores/Account/Types");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var WidgetMenuButton_1 = __importDefault(require("../WidgetMenuButton"));
var AccordionStylesPanel_1 = __importDefault(require("./AccordionStylesPanel"));
var BASE_CLASS_NAME = "accordion-widget--toolbar";
var AccordionToolbar = (function (_super) {
    __extends(AccordionToolbar, _super);
    function AccordionToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStylesClick = function () {
            _this.isShowingContextualStyles = !_this.isShowingContextualStyles;
        };
        return _this;
    }
    AccordionToolbar.prototype.render = function () {
        var _a = this.props, blockStore = _a.blockStore, brandStore = _a.brandStore, onClickDelete = _a.onClickDelete, onClickClone = _a.onClickClone, telemetry = _a.telemetry, usingVisualAccordion = _a.usingVisualAccordion, onVisualAccordionSelected = _a.onVisualAccordionSelected, stylePermissionStore = _a.stylePermissionStore;
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, " editor-toolbar"), contentEditable: false },
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Copy, null), onMouseDown: onClickClone }),
            stylePermissionStore && stylePermissionStore.allowStyle(Types_1.StyleAccessType.Accordion) && (react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Styles, null), onMouseDown: this.handleStylesClick })),
            react_1.default.createElement(WidgetMenuButton_1.default, { icon: react_1.default.createElement(icons_1.Delete, null), onMouseDown: onClickDelete, isDestructive: true }),
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "-styles-wrapper"), contentEditable: false },
                react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, this.isShowingContextualStyles && (react_1.default.createElement(AccordionStylesPanel_1.default, { blockStore: blockStore, brandStore: brandStore, telemetry: telemetry, usingVisualAccordion: usingVisualAccordion, onVisualAccordionSelected: onVisualAccordionSelected }))))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], AccordionToolbar.prototype, "isShowingContextualStyles", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccordionToolbar.prototype, "handleStylesClick", void 0);
    AccordionToolbar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AccordionToolbar);
    return AccordionToolbar;
}(react_1.default.Component));
exports.AccordionToolbar = AccordionToolbar;
exports.default = AccordionToolbar;
